import { createContext, useContext } from 'react';

/**
 * The context object behind ConfirmProvider, and the two hooks that read it.
 *
 * WHY THIS IS ITS OWN FILE, with no UI imports:
 *
 * createContext() produces a new, unequal object every time its module runs.
 * ConfirmContext.jsx imports Modal, Button and Input — so under the dev server,
 * editing any one of those re-executed ConfirmContext.jsx and minted a FRESH
 * context object. Consumers re-executed by the same update read the new object
 * while the mounted <Provider> still held the old one, and any component
 * mounting for the first time after that got null and threw
 * "useDialogs must be used inside <ConfirmProvider>". Switching theme is exactly
 * such a first mount: V1V2Shell appears, calls useDialogs, and blows up on a
 * tree that is in fact correctly wrapped.
 *
 * Keeping the context here means it is re-created only when THIS file changes —
 * which is close to never — no matter how much the dialog's UI is edited.
 */
export const ConfirmContext = createContext(null);

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm must be used inside <ConfirmProvider>');
  return ctx.confirm;
}

export function useDialogs() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useDialogs must be used inside <ConfirmProvider>');
  return ctx;
}
